import React from 'react';
import StackedList from "components/StackedList";
import StackedListItem from "components/StackedListItem";
import Card from "components/Card";
import {useQuery} from "react-query";
import ngage from "../../../services/ngage";
import StatList from "../../StatList";
import StatBoxSimple from "../../StatBoxSimple";
import Divider from "../../Divider";
import Link from "../../Link";
import Button from "../../Button";
import {useNavigate} from "react-router-dom";
import {PlusIcon} from "@heroicons/react/solid";

// Types ----

type ContactsCardProps = {
  ownerId: number
}

// Component ----

function ContactsCard({ownerId}: ContactsCardProps) {
  const navigate = useNavigate();

  function handleAddContact() {
    navigate(`/contacts/new?ownerId=${ownerId}`);
  }

  const {data: contacts, isLoading: isLoadingContacts} = useQuery(
    ['contacts.all', {holder: ownerId}],
    () => ngage.contacts.filtered({owner: ownerId}),
    {keepPreviousData: true}
  )

  return (
    <Card
      heading="Contacts"
      isLoading={isLoadingContacts}
      action={
        <Button
          color={Button.colors.SECONDARY}
          icon={PlusIcon}
          onClick={handleAddContact}
        >
          Add Contact
        </Button>
      }
    >
      <StatList columns={2}>
        <StatBoxSimple name='Total' stat={contacts?.data?.length ?? 0}/>
      </StatList>

      {!contacts?.data?.length ? (
        <div className="mt-6 flow-root">
          <Divider/>
          <p className="text-sm text-gray-400 mt-6">No contacts</p>
        </div>
      ) : (
        <div className="mt-6">
          <StackedList>
            {contacts?.data?.map((contact) => (
              <StackedListItem hasLink={true} key={contact.id}>
                <Link to={`/contacts/${contact.id}/edit`}>
                  <div className="grid grid-cols-1 gap-1 font-normal text-sm text-gray-900">
                    <p>
                      <span className="mr-1.5 text-gray-400">Name:</span>
                      {contact.full_name}
                    </p>
                  </div>
                </Link>
              </StackedListItem>
            ))}
          </StackedList>
        </div>
      )}
    </Card>
  );
}

// Export ----

export default ContactsCard;